import * as React from "react";
import { cn } from "@/lib/utils";
import { Badge } from "./badge"; // Importando o arquivo acima

type StatusBadgeProps = React.HTMLAttributes<HTMLDivElement> & {
  children: React.ReactNode;
  /**
   * String de classes CSS vinda dos seus MAPs constantes.
   * Ex: 'bg-amber-50 text-amber-700 border border-amber-200'
   */
  color?: string;
};

export function StatusBadge({ children, color, className, ...props }: StatusBadgeProps) {
  return (
    <Badge
      variant="outline"
      // O 'cn' mescla o 'outline' padrão com o seu 'color'.
      // Como o 'color' vem depois, ele ganha a prioridade.
      className={cn("bg-background", color, className)}
      {...props}
    >
      {children}
    </Badge>
  );
}
